module.exports = __webpack_public_path__ + "img/Thinking.5807a3f3.gif";